<mat-calendar-header />
<div class="absolute! top-10 left-20 text-neut-40 body-2">Exact Date</div>
<mat-date-range-picker-actions>
  <div class="flex flex-col w-full">
    <div class="body-2 text-neut-40 my-10 ml-15">Relative</div>
    <div class="grid grid-cols-2 gap-10 items-center justify-center">
      @for (range of rangePresets; track range) {
        <button
          matButton="filled"
          class="h-36! rounded-[18px]! bg-charcoal-80 text-neut-var-10 text-16! px-10! ml-0!"
          [ngClass]="{ 'bg-charcoal-10! text-white!': range === selectedDateRange }"
          (click)="selectRange(range)">
          {{ range }}
        </button>
      }
    </div>
  </div>
</mat-date-range-picker-actions>
